// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","fullWidth":"Button_fullWidth__xiCcj","outlined":"Button_outlined__-tAZi","solid":"Button_solid__eXqzP","link":"Button_link__vM+72"};